import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  typography: {
    textOverflow: 'ellipsis',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
    minHeight: '20px',
  },
  viewFieldWrapper: {
    ...theme.mixins.appContainer,
    display: 'flex',
    justifyContent: 'space-between',
  },
  viewFieldWrapperNoShadow: {
    boxShadow: 'none',
  },
  viewFieldContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
  },
  label: {
    ...theme.mixins.appLabel,
  },
  labelRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  tooltip: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  labelPrimary: {
    color:
      (theme.palette as { font?: { primary?: string } }).font?.primary ??
      theme.palette.text.primary,
  },
  startAdornment: {
    marginRight: theme.spacing(1.5),
    flexShrink: 0,
  },
}));
